"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelfSignedCertificate = createSelfSignedCertificate;
const forge = __importStar(require("node-forge"));
const SAN_TYPE_DNS = 2;
// TODO: move to DHT? might need in tests for autocertifier-client
function createSelfSignedCertificate(fqdn, validMonths) {
    if (validMonths <= 0) {
        throw new Error('validMonths must be greater than 0');
    }
    // Generate a new RSA key pair for the certificate authority
    const caKeys = forge.pki.rsa.generateKeyPair(2048);
    // Create a new X.509 certificate for the certificate authority
    const caCert = forge.pki.createCertificate();
    caCert.publicKey = caKeys.publicKey;
    caCert.serialNumber = '01'; // Serial number is required but not important for self-signed certificates
    caCert.validity.notBefore = new Date();
    caCert.validity.notAfter = new Date();
    caCert.validity.notAfter.setMonth(caCert.validity.notBefore.getMonth() + validMonths);
    const attrs = [
        { name: 'commonName', value: fqdn },
        { name: 'countryName', value: '-' },
        { shortName: 'ST', value: '-' },
        { name: 'localityName', value: '-' },
        { name: 'organizationName', value: '-' },
        { shortName: 'OU', value: '-' }
    ];
    caCert.setSubject(attrs);
    caCert.setIssuer(attrs);
    caCert.setExtensions([
        { name: 'basicConstraints', cA: true },
        { name: 'keyUsage', keyCertSign: true, digitalSignature: true, nonRepudiation: true, keyEncipherment: true, dataEncipherment: true },
        { name: 'subjectKeyIdentifier' }
    ]);
    caCert.sign(caKeys.privateKey, forge.md.sha256.create());
    // Generate a new RSA key pair for the server certificate
    const serverKeys = forge.pki.rsa.generateKeyPair(2048);
    // Create a new X.509 certificate for the server
    const serverCert = forge.pki.createCertificate();
    serverCert.publicKey = serverKeys.publicKey;
    serverCert.serialNumber = '01'; // Serial number is required but not important for self-signed certificates
    serverCert.validity.notBefore = new Date();
    serverCert.validity.notAfter = new Date();
    serverCert.validity.notAfter.setFullYear(serverCert.validity.notBefore.getFullYear() + 1);
    serverCert.setSubject(attrs);
    serverCert.setIssuer(caCert.subject.attributes);
    serverCert.setExtensions([
        { name: 'basicConstraints', cA: false },
        { name: 'keyUsage', digitalSignature: true, nonRepudiation: true, keyEncipherment: true, dataEncipherment: true },
        { name: 'subjectAltName', altNames: [{ type: SAN_TYPE_DNS, value: fqdn }] },
        { name: 'subjectKeyIdentifier' }
    ]);
    serverCert.sign(caKeys.privateKey, forge.md.sha256.create());
    return {
        caCert: forge.pki.certificateToPem(caCert),
        caKey: forge.pki.privateKeyToPem(caKeys.privateKey),
        serverCert: forge.pki.certificateToPem(serverCert),
        serverKey: forge.pki.privateKeyToPem(serverKeys.privateKey)
    };
}
//# sourceMappingURL=createSelfSignedCertificate.js.map